"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.default = async (promises) => {
    for (let i = 0; i < promises.length; i++) {
        await promises[i];
    }
};
//# sourceMappingURL=chain.js.map